<template>
  <b-row>
    <b-col :cols='12'>
      <b-form>
        <b-alert :show='alertSaved == 1' variant='success' dismissible>Guardado satisfactoriamente</b-alert>
        <b-alert :show='alertSaved == 2' variant='danger' dismissible>Error (GC-GUARDADO)</b-alert>

        <b-row>
          <b-col :cols='5'>
            <b-form-group id="exampleInputGroup1"
                          label="Entidad:"
                          label-for="exampleInput1"
                          description="">

              <multiselect
                placeholder="Seleccionar"
                deselect-label="Click o enter para deseleccionar"
                select-label="Click o enter para seleccionar"
                v-model="inputs.entity.value"
                :options="inputs.entity.options"
                v-validate="'required'"
                :multiple="false" :close-on-select="true"
                :clear-on-select="true"
                :preserve-search="true"
                label="name"
                track-by="value"
                name="Entidad"
                :preselect-first="true">
              </multiselect>
              <span class="error">{{ errors.first('Entidad') }}</span>
            </b-form-group>
          </b-col>
          <b-col :cols='2'>
            <b-form-group id="inputGroup" class="mt-24">
              <b-button @click='showPublicOffer()' size='lg' variant='default'><i class='p-0 fa fa-eye'></i>&nbsp;
                Oferta pública
              </b-button>
            </b-form-group>
          </b-col>
          <b-col :cols='5'>
            <b-form-group id="exampleInputGroup1"
                          label="Distribuidora:"
                          label-for="exampleInput1"
                          description="">
              <b-form-select v-model="inputs.distributor.value" :options="inputs.distributor.options" class="mb-3"
                             size="sm"/>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col :cols='4'>
            <b-form-group id="exampleInputGroup1"
                          label="Visitador:"
                          label-for="exampleInput1"

                          description="">
              <b-form-input id="exampleInput1"
                            :disabled='true'
                            type="text"
                            v-model="inputs.visitador"
                            required
                            placeholder="Enter text">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col :cols='2'>
            <b-form-group id="exampleInputGroup1"
                          label="Estado:"
                          label-for="exampleInput1"
                          description="">
              <b-form-select v-model="inputs.status.value" :options="inputs.status.options" class="mb-3" size="sm"/>
            </b-form-group>
          </b-col>

          <b-col :cols='3'>
            <b-form-group id="exampleInputGroup1"
                          label="Fecha visita planificada:"
                          label-for="exampleInput1"
                          description="">
              <b-input-group>
                <datetime
                  v-validate="(inputs.status.value === 1) ? 'required':''"
                  name="Fecha y hora planificada"
                  v-model="inputs.scheduledDate"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  :format="{
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                  hour: 'numeric',
                                  minute: '2-digit',
                                  hour12: false
                                  }"
                  zone="local">
                </datetime>
                <b-input-group-text slot="append" @click="inputs.scheduledDate = ''">
                  <strong class="text-danger"><i class="fa fa-times"></i></strong>
                </b-input-group-text>
              </b-input-group>
              <span class="error">{{ errors.first('Fecha y hora planificada') }}</span>
            </b-form-group>
          </b-col>
          <b-col :cols='3'>
            <b-form-group id="exampleInputGroup1"
                          label="Fecha visita realizada:"
                          label-for="exampleInput1"
                          description="">
              <b-input-group>
                <datetime
                  v-validate="(inputs.status.value === 3) ? 'required':''"
                  name="Fecha y hora realizada"
                  v-model="inputs.visitedDate"
                  :max-datetime="currentDate"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  :format="{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: false
                                    }"
                  zone="local">
                </datetime>
                <b-input-group-text slot="append" @click="inputs.visitedDate = ''">
                  <strong class="text-danger"><i class="fa fa-times"></i></strong>
                </b-input-group-text>
              </b-input-group>
              <span class="error">{{ errors.first('Fecha y hora realizada') }}</span>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col :cols='4'>
            <b-form-group id="exampleInputGroup1"
                          label="Tipo actividad:"
                          label-for="exampleInput1"
                          description="">
              <b-form-select v-model="inputs.activityType.value" :options="inputs.activityType.options" class="mb-3"
                             size="sm"/>
            </b-form-group>
          </b-col>

          <b-col :cols='2'>
            <b-form-group id="exampleInputGroup1"
                          label="Resultado:"
                          label-for="exampleInput1"
                          description="">
              <b-form-select v-model="inputs.result.value" :options="inputs.result.options" class="mb-3" size="sm"/>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col :cols='4'>
            <b-form-group id="exampleInputGroup1"
                          label="Observaciones:"
                          label-for="exampleInput1"
                          description="">
              <b-form-textarea :rows='4' v-model="inputs.comments" class="mb-3" size="sm" name="Observaciones"
                               v-validate="ObsValidate"/>
              <span class="error">{{ errors.first('Observaciones') }}</span>
            </b-form-group>
          </b-col>

          <b-col :cols='4'>
            <b-form-group id="exampleInputGroup1"
                          label="Invitados:"
                          label-for="exampleInput1"
                          description="">
              <b-form-textarea :rows='4' v-model="inputs.guests" class="mb-3" size="sm"/>
            </b-form-group>
          </b-col>

          <b-col :cols='4'>
            <b-form-group id="exampleInputGroup1" class="mt-32">
              <a target="_top" :href="sendEmailGuests">
                <b-button size='sm' variant='default'>
                  <i class='p-0 fa fa-envelope'></i>&nbsp; Enviar correo a invitados
                </b-button>
              </a>
            </b-form-group>
          </b-col>

          <!-- <b-col :cols='6'>
             <b-form-group id="exampleInputGroup1"
                             label="Visitado por gestor:"
                             label-for="exampleInput1"
                             description="">
                 <switches
                     v-model="inputs.visitedByManager"
                     style="margin-top: .5rem;"
                     color="blue">
                 </switches>
             </b-form-group>
         </b-col> -->

        </b-row>
        <b-row>
          <b-col style="text-align: right;">
            <b-button type="reset" @click='goBackDetails()' variant="default">Volver a lista</b-button>
            <b-button @click='saveVisit' variant="primary">Guardar</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
    <div v-if="showAlert" class="div-full">
      <b-alert class="alert-class" show dismissible variant="primary" @dismissed="showAlert=false">
        {{ alertText }}
      </b-alert>
    </div>
  </b-row>
</template>

<style scoped>
.div-full {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0000006b;
}

.alert-class {
  position: relative;
  top: 50%;
  width: 75%;
  left: 15%;
}

.mt-24 {
  margin-top: 24px;
}

.mt-32 {
  margin-top: 32px;
}

</style>

<script>

import Datepicker from 'vuejs-datepicker';
import Switches from 'vue-switches';
import moment from 'moment';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'ManageVisitsEntitiesResultsEdit',
  props: ['id-visita', 'manager'],
  components: {Datepicker, Switches},
  data () {
    return {
      showAlert: false,
      alertText: '',
      alertSaved: 0,
      inputs: {
        distributor: {
          options: [],
          value: null
        },
        entity: {
          value: null,
          options: []
        },
        visitador: '',
        status: {
          options: [],
          value: null
        },
        scheduledDate: null,
        visitedDate: null,
        activityType: {
          options: [],
          value: null
        },
        result: {
          options: [],
          value: null
        },
        comments: null,
        guests: null,
        visitedByManager: false
      }
    };
  },
  computed: {
    currentDate: function () {
      return moment().format();
    },
    ObsValidate: function () {
      // return 'required|max:1000'
      if (this.inputs.status.value === 3) {
        return 'required|max:1000';
      } else {
        return 'max:1000';
      }
    },
    sendEmailGuests: function () {
      if (this.inputs.guests) {
        var subject = '[Asunto provisional] Por determinar';

        return 'mailto:' + this.inputs.guests.replace(';', ',') + '?subject=' + subject;
      }
    }
  },
  created: function () {
    this.processData();
    // this.populateDistributors()
    // this.populateEntities()
  },
  mounted: function () {

  },
  methods: {

    showPublicOffer: function () {
      if (this.inputs.entity.value) {
        this.$http.get('entidades_op/', {params: {codigo_entidad: this.inputs.entity.value.codigoEntidad}}).then(response => {
          // console.log(response)
          // alert(response.body.map((obj) => { return obj.distribuidora }))
          var list = response.body.map((obj) => {
            return obj.distribuidora;
          });
          this.alertText = list.join(', ');
          this.showAlert = true;
        });
      }
    },
    populateEntities: function (response) {
      let options = [];

      var data = response.body;

      for (let i = 0; i < data.length; ++i) {
        options.push({
          value: data[i]['id'],
          codigoEntidad: data[i]['codigo_entidad'],
          name: data[i]['nombre_entidad'] + '(CIF: ' + data[i]['cif'] + ') - (SAP:' + data[i]['codigo_entidad'] + ')'
        });
      }

      this.inputs.entity.options = options;
    },

    populateDistributors: function (response) {
      let options = [];
      for (const distribuidora of response.data) {
        options.push({
          value: distribuidora.nombre,
          text: distribuidora.nombre
        });
      }

      this.inputs.distributor.options = options;
    },

    saveVisit () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.alertSaved = false;

          let modifications = {};

          modifications['partial'] = true;

          modifications['status_visita'] = this.inputs.status.options.filter(e => e.value === this.inputs.status.value)[0].text;

          if (this.inputs.visitedDate !== null && this.inputs.visitedDate !== '') {
            modifications['fecha_hora_visita'] = this.inputs.visitedDate.split('+')[0] + '+00:00';
          }
          if (this.inputs.scheduledDate !== null && this.inputs.scheduledDate !== '') {
            modifications['fecha_hora_proxima_visita'] = this.inputs.scheduledDate.split('+')[0] + '+00:00';
          }

          modifications['tipo_actividad_visita_entidad'] = this.inputs.activityType.options.filter(e => e.value === this.inputs.activityType.value)[0].text;
          modifications['id_resultado_visita'] = this.inputs.result.value;
          modifications['observaciones'] = this.inputs.comments;
          modifications['invitados'] = this.inputs.guests;

          modifications['distribuidora'] = this.inputs.distributor.value;
          modifications['id_entidad'] = this.inputs.entity.value.value;

          // modifications[]

          this.$http.patch('visitas_entidades/' + this.idVisita + '/', modifications).then(result => {
            this.alertSaved = 1;
          }, error => {
            console.log(error);
            this.alertSaved = 2;
            // console.log(error)
            // this.$http.post('correccion_comercial/', this.modification).then(result => {
            //     alert('Guardado con éxito!')
            //     this.loading = false
            // })
          });
        }
      });
    },

    goBackDetails () {
      this.$parent.editingVisit = 0;
    },

    processData () {
      Promise.all([
        this.$http.get('status_visitas/', {params: {not_paginated: true}}),
        this.$http.get('tipo_actividad_visitas_entidades/', {params: {not_paginated: true}}),
        this.$http.get('resultados_visitas/', {params: {not_paginated: true}}),
        this.$http.get('distribuidoras/'),
        this.$http.get('entities/')
      ]).then(results => {
        this.inputs.status.options = results[0].data.map((obj) => {
          return {text: obj.visita_status, value: obj.id};
        });
        this.inputs.activityType.options = results[1].data.map((obj) => {
          return {text: obj.descripcion, value: obj.id};
        });
        this.inputs.result.options = results[2].data.map((obj) => {
          return {text: obj.resultado, value: obj.id};
        });

        this.populateDistributors(results[3]);
        this.populateEntities(results[4]);

        this.$http.get('visitas_entidades/' + this.idVisita + '/').then(responseVisita => {
          const data = responseVisita.body;

          this.inputs.visitador = data.nombre_visitador + (' (' + data.codigo_visitador + ')');

          let currentDistributorValue = this.inputs.distributor.options.filter(e => e.text === data.distribuidora);
          if (currentDistributorValue.length > 0) {
            this.inputs.distributor.value = currentDistributorValue[0].value;
          }

          this.inputs.entity.value = this.inputs.entity.options.filter(e => e.value === data.id_entidad)[0];

          // OK

          if (data.fecha_hora_visita) {
            this.inputs.visitedDate = data.fecha_hora_visita;
          }

          if (data.fecha_hora_proxima_visita !== null) {
            this.inputs.scheduledDate = data.fecha_hora_proxima_visita;
          } // .split('+')[0] + '+00:00' }

          this.inputs.activityType.value = this.inputs.activityType.options.filter(e => e.text === data.tipo_actividad_visita_entidad)[0].value;

          if (data.id_resultado_visita_dict) {
            this.inputs.result.value = data.id_resultado_visita_dict.id;
          }

          this.inputs.status.value = this.inputs.status.options.filter(e => e.text === data.status_visita)[0].value;

          this.inputs.comments = data.observaciones;
          this.inputs.guests = data.invitados;
          // this.inputs.visitedByManager = data.visitado_gestor
        });
      });
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsEntitiesResultsEdit.vue